(function () {
  function initSlider(root) {
    var slider = root.querySelector('.qg-slider');
    var btn = root.querySelector('[data-qg-slider-next]');
    if (!slider || !btn || slider.dataset.qgInit === '1') return;
    slider.dataset.qgInit = '1';

    var slides = slider.querySelectorAll('.qg-slide');
    if (!slides.length) return;
    var index = 0;

    function update() {
      var atEnd = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 4;
      btn.innerHTML = atEnd ? '\u2039' : '\u203A';
      btn.setAttribute('aria-label', atEnd ? 'Previous testimonial' : 'Next testimonial');
    }

    btn.addEventListener('click', function () {
      var atEnd = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 4;
      if (atEnd) {
        slider.scrollTo({ left: 0, behavior: 'smooth' });
        index = 0;
      } else {
        index = Math.min(index + 1, slides.length - 1);
        var slide = slides[index];
        if (slide) slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      }
    });

    var scrollTimer;
    slider.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(update, 80);
    });

    update();
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-qg-slider-root]');
    roots.forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-qg-slider-root]');
    if (root) initSlider(root);
  });
})();
